import { call, put, takeEvery, takeLeading } from "redux-saga/effects"
import * as api from "./api"

// Events Redux States
import { GET_SESSION, GET_SETTINGS, LOGIN, LOGIN_FAILURE, LOGOUT } from "./actionTypes"
import { apiError, getSessionSuccess, getSessionUnavailable, getSettingsFailure, getSettingsSuccess } from "./actions"

const isTimeout = error => error?.code === "ECONNABORTED" || error?.code === "ETIMEDOUT"

// No answer, a timeout or a 5xx says nothing about the session: keep the user
// on the page with a retry instead of sending them to sign in again.
const unavailableReason = error => {
  if (isTimeout(error)) return "timeout"
  if (!error?.response) return "network"
  return error.response.status >= 500 ? "server" : null
}

function* getSession({ payload: [] }) {
  try {
    const { data } = yield call(
      api.getSession,
    )
    yield put(getSessionSuccess(data))

  } catch (error) {
    const reason = unavailableReason(error)
    yield put(reason ? getSessionUnavailable(reason) : apiError(error))
  }
}

const allowedRoles = ["admin", "superAdmin"]

function* login({ payload: { values, history} }) {
  try {
    const { data } = yield call(
      api.login,
      values
    )

    if (
      !data ||
      (data && data.error) ||
      (data && !allowedRoles.includes(data.role))
    ) {
      yield put({ type: LOGIN_FAILURE, payload: "The administrative session could not be confirmed. Please sign in again." })
      return
    }

    yield put(getSessionSuccess(data))
    return history.push("/")

  } catch (error) {
    const status = error?.response?.status
    const message = isTimeout(error)
      ? "The server took too long to respond. Please try again."
      : !error?.response ? "Cannot connect to the server. Check your connection and try again."
      : status === 401 || status === 403 ? "Sign-in failed. Check your credentials and administrative access."
      : status === 429 ? "Too many sign-in attempts. Please wait before trying again."
      : "Sign-in is temporarily unavailable. Please try again."
    yield put({ type: LOGIN_FAILURE, payload: message })
  }
}

function* logout({ payload: [] }) {
  try {
    const { data } = yield call(
      api.logout,
      values
    )

    console.log(data);

    return history.push("/");

  } catch (error) {
    yield put(apiError(error))
  }
}

function* getSettings({ payload: [] }) {
  try {
    const { data } = yield call(
      api.getSettings,
    )
    yield put(getSettingsSuccess(data))

  } catch (error) {
    // Settings are not the session: a failed read must not sign the user out.
    yield put(getSettingsFailure(error))
  }
}

function* eventsSaga() {
  yield takeEvery(GET_SESSION, getSession)
  yield takeEvery(GET_SETTINGS, getSettings)
  yield takeLeading(LOGIN, login)
  yield takeEvery(LOGOUT, logout)
}

export default eventsSaga
